import Layout from 'layout';
import PrequalificationReviewFormEdit from 'features/PrequalificationReview/pages/Edit';
import { LayoutProvider } from '../layout/context/layoutcontext';

function PrequalificationReviewFormEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <PrequalificationReviewFormEdit />
      </Layout>
    </LayoutProvider>
  );
}

export default PrequalificationReviewFormEditPage;
